import { render, staticRenderFns } from "./DatePicker.vue?vue&type=template&id=635c049c&scoped=true"
import script from "./DatePicker.vue?vue&type=script&lang=ts"
export * from "./DatePicker.vue?vue&type=script&lang=ts"
import style0 from "./DatePicker.vue?vue&type=style&index=0&id=635c049c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635c049c",
  null
  
)

export default component.exports